import React, { useMemo } from 'react'
import { format, parseISO, isValid } from 'date-fns';
import {
  Typography,
  makeStyles, createStyles, Theme,
  Grid, FormControlLabel, Checkbox
} from '@material-ui/core';
import { typeBasicInfo } from '../../../../api/helpline/keiyaku'


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '20%',
      flexShrink: 0,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
      flexGrow: 1,
    },
    chip: {
      color: theme.palette.text.secondary
    },
    label: {
      fontSize: theme.typography.pxToRem(12),
      fontWeight: theme.typography.fontWeightBold,
    }
  }),
);
interface Prop {
  basicInfo: typeBasicInfo | undefined,
  mailservice: boolean[] | null,
}

const BasicInfo: React.FC<Prop> = (props) => {
  const classes = useStyles()
  const { basicInfo, mailservice } = props
  const dateFormat = (datevalue: Date | string | null): string => {
    let date = datevalue
    if (typeof date === 'string') {
      date = parseISO(date)
    }
    if (date && isValid(date)) {
      return format(date, "yyyy/MM/dd")
    } else {
      return '　'
    }
  }

  const priceFormat = (price: number): string => {
    const formatter = new Intl.NumberFormat('ja-JP');
    if (typeof price === 'number') {
      return formatter.format(price)
    } else {
      return '　'
    }
  }
  const monthFormat = (month: string) => {
    let displaymonth = month.replace(/,/g, '月, ') + '月'
    return displaymonth
  }

  const newLine = (str: string) => {
    return str.split(/\r\n|\n/).map((value, index) => {
      if (value) {
        return <Typography>{value}</Typography>
      } else {
        return <br />
      }
    })
  }

  const incidentDepositView = useMemo((): boolean => {
    if (basicInfo?.keiyakuClsCd === 'OI') {
      return true
    } else if (basicInfo?.keiyakuClsNotes === '11' || basicInfo?.keiyakuClsNotes === '12') {
      return true
    } else {
      return false
    }
  }, [basicInfo])

  const visitCountView = useMemo((): boolean => {
    if (basicInfo?.keiyakuClsCd === 'OI') {
      return false
    } else if (basicInfo?.keiyakuClsNotes === '10' || basicInfo?.keiyakuClsNotes === '11' || basicInfo?.keiyakuClsNotes === '12') {
      return false
    } else {
      return true
    }
  }, [basicInfo])

  return (
    <React.Fragment>
      {basicInfo &&
        <Grid container direction="row" justify="center" alignItems="center" spacing={1}>
          <Grid item xs={11}>
            <Typography className={classes.label}>顧客名 / 組織名</Typography>
            <Typography>{basicInfo.custmName}</Typography>
          </Grid>
          <Grid item xs={11}>
            <Grid container direction="row" justify="flex-start" alignItems="center">
              <Grid item xs={12} md={3}>
                <Typography className={classes.label}>契約書番号</Typography>
                <Typography>{basicInfo.keiyakuNo}</Typography>
              </Grid>
              <Grid item xs={12} md={3}>
                <Typography className={classes.label}>受注番号</Typography>
                <Typography>{basicInfo.orderNo}</Typography>
              </Grid>
              <Grid item xs={12} md={3}>
                <Typography className={classes.label}>契約開始日</Typography>
                <Typography>{dateFormat(basicInfo.keiyakuStartTs)}</Typography>
              </Grid>
              {basicInfo.kaiyakuTs ?
                (<Grid item xs={12} md={3}>
                  <Typography className={classes.label}>解約日</Typography>
                  <Typography>{dateFormat(basicInfo.kaiyakuTs)}</Typography>
                </Grid>
                ) : basicInfo.renewalMonth && (
                  <Grid item xs={12} md={3}>
                    <Typography className={classes.label}>契約更新月</Typography>
                    <Typography>{monthFormat(basicInfo.renewalMonth)}</Typography>
                  </Grid>
                )}
            </Grid>
          </Grid>
          <Grid item xs={11} md={5}>
            <Typography className={classes.label}>契約項目</Typography>
            <Typography>{basicInfo.keiyakuClsName}</Typography>
          </Grid>
          <Grid item xs={11} md={6}>
            <Typography className={classes.label}>契約担当者</Typography>
            <Typography>{basicInfo.keiyakuPersonName}</Typography>
          </Grid>
          <Grid item xs={11} md={3}>
            <Typography className={classes.label}>担当部署</Typography>
            <Typography>{basicInfo.keiyakuPersonDeptName ? basicInfo.keiyakuPersonDeptName : '　'}</Typography>
          </Grid>
          <Grid item xs={11} md={3}>
            <Typography className={classes.label}>電話番号</Typography>
            <Typography>{basicInfo.keiyakuPersonTel}</Typography>
          </Grid>
          <Grid item xs={11} md={3}>
            <Typography className={classes.label}>E-Mail</Typography>
            <Typography>{basicInfo.keiyakuPersonEmail}</Typography>
          </Grid>
          <Grid item xs={11} md={2}>
            <Typography className={classes.label}>担当営業者</Typography>
            <Typography>{basicInfo.salesPersonName ? basicInfo.salesPersonName : '　'}</Typography>
          </Grid>
          <Grid item xs={11}>
            <Grid container direction="row" justify="flex-start" alignItems="center">
              <Grid item xs={12} md={3}>
                <Typography className={classes.label}>契約金額</Typography>
                <Typography>{basicInfo.keiyakuDeposit && (priceFormat(basicInfo.keiyakuDeposit))} 円</Typography>
              </Grid>
              {incidentDepositView &&
                <Grid item xs={12} md={3}>
                  <Typography className={classes.label}>ｵﾝｻｲﾄｲﾝｼﾃﾞﾝﾄｻｰﾋﾞｽ金額</Typography>
                  <Typography>{basicInfo.incidentDeposit && (priceFormat(basicInfo.incidentDeposit))} 円</Typography>
                </Grid>
              }
              <Grid item xs={12} md={3}>
                <Typography className={classes.label}>合計金額</Typography>
                <Typography>{basicInfo.totalPrice && (priceFormat(basicInfo.totalPrice))} 円</Typography>
              </Grid>
              <Grid item xs={12} md={3}>
                <Typography className={classes.label}>支払方法</Typography>
                <Typography>{basicInfo.payClsName}</Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={11}>
            <Grid container direction="row" justify="flex-start" alignItems="center">
              {basicInfo.keiyakuClsCd === 'OI' &&
                <React.Fragment>
                  <Grid item xs={11} md={3}>
                    <Typography className={classes.label}>有効インシデント</Typography>
                    <Typography>{basicInfo.incidentCount}</Typography>
                  </Grid>
                  <Grid item xs={11} md={3}>
                    <Typography className={classes.label}>追加インシデント</Typography>
                    <Typography>{basicInfo.incidentAddCount}</Typography>
                  </Grid>
                  <Grid item xs={11} md={3}>
                    <Typography className={classes.label}>使用済みインシデント</Typography>
                    <Typography>{basicInfo.incidentUsedCount}</Typography>
                  </Grid>
                </React.Fragment>
              }
              {visitCountView &&
                <Grid item xs={11} md={2}>
                  <Typography className={classes.label}>基本訪問回数</Typography>
                  <Typography>{basicInfo.visitCount} 回</Typography>
                </Grid>}
            </Grid>
          </Grid>

          <Grid item xs={11}>
            <Typography className={classes.label}>オプション契約内容</Typography>
            <Typography>{basicInfo.keiyakuOption ? newLine(basicInfo.keiyakuOption) : '　'}</Typography>
          </Grid>
          <Grid item xs={11}>
            <Typography className={classes.label}>備考</Typography>
            <Typography>{basicInfo.keiyakuNote ? newLine(basicInfo.keiyakuNote) : '　'}</Typography>
          </Grid>
          <Grid item xs={11}>
            <Typography className={classes.label}>メール通知サービス設定</Typography>
            {mailservice ?
              <React.Fragment>
                <Grid>
                  <FormControlLabel control={<Checkbox checked={mailservice[0]} disabled size="small" name="mailservice3" />}
                    label="QAの回答が登録されたことを通知"
                  />
                </Grid>
                <Grid>
                  <FormControlLabel control={<Checkbox checked={mailservice[1]} disabled size="small" name="mailservice5" />}
                    label="QAのステータスが終了になったことを通知"
                  />
                </Grid>
              </React.Fragment>
              : <Typography>　</Typography>}
          </Grid>
          <Grid xs={11}>
            <Grid container direction="row" justify="flex-start" alignItems="center">
              <Grid item style={{ marginRight: '12px' }}>
                <Typography className={classes.label}>機械設置場所 〒</Typography>
                <Typography>{basicInfo.machineSettingZipCd}</Typography>
              </Grid>
              <Grid item>
                <Typography className={classes.label}>機械設置場所 住所</Typography>
                <Typography>{basicInfo.machineSettingAddress}</Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      }
    </React.Fragment >
  )
}

export default BasicInfo